/*
 * Where share images (Open Graph / Twitter cards) live. CommonJS, no packages:
 * next.config.js requires it at build time, the pages use it to build URLs.
 *
 *   /og/{version}/{locale}/{card}.jpg        public URL, in every page's og:image
 *   /api/og/{version}/{locale}/{card}        the handler (src/pages/api/og/[...path].js)
 *
 * The public URL is outside /api/ on purpose: robots.txt disallows /api/ and
 * src/noindex-routes.js marks it noindex, and social crawlers (Twitterbot,
 * LinkedInBot, facebookexternalhit, Slackbot) may honour both.
 *
 * A card is addressed by what it is about, never by what it says: the handler
 * looks the name, logo and numbers up itself (src/lib/share-image/cards.js).
 */

/**
 * Part of every image URL. Bump it when the design changes: every page then
 * points at a new URL, which CDNs and social networks have never cached.
 * Also re-render the static default (`pnpm run render-share-default`).
 */
const SHARE_IMAGE_VERSION = 'v1';

const SHARE_IMAGE_PATH = '/og';
const SHARE_IMAGE_API_PATH = '/api/og';

const SHARE_IMAGE_EXTENSION = '.jpg';
const SHARE_IMAGE_TYPE = 'image/jpeg';

/** Netlify cache tag on every response of the image function, for purging without a deploy. */
const SHARE_IMAGE_CACHE_TAG = 'share-image';

const SHARE_IMAGE_WIDTH = 1200;
const SHARE_IMAGE_HEIGHT = 630;

/** Committed fallback: the home card in English, rendered once from the same template. */
const DEFAULT_SHARE_IMAGE_PATH = '/images/social/og-default.jpg';

/**
 * Rewrite for `rewrites()` in next.config.js. `locale: false` with the default
 * locale spelt out, like the rules in legacy-routes.js: Next matches against a
 * path that always carries a locale (`/en/og/…` for `/og/…`). The locale of the
 * image is a path segment after the version, so `/fr/og/…` does not exist.
 *
 * @param {object} options
 * @param {{ defaultLocale: string }} options.i18n
 */
const buildShareImageRewrites = ({ i18n }) => [
  {
    source: `/${i18n.defaultLocale}${SHARE_IMAGE_PATH}/:path*`,
    destination: `/${i18n.defaultLocale}${SHARE_IMAGE_API_PATH}/:path*`,
    locale: false,
  },
];

module.exports = {
  DEFAULT_SHARE_IMAGE_PATH,
  SHARE_IMAGE_API_PATH,
  SHARE_IMAGE_CACHE_TAG,
  SHARE_IMAGE_EXTENSION,
  SHARE_IMAGE_HEIGHT,
  SHARE_IMAGE_PATH,
  SHARE_IMAGE_TYPE,
  SHARE_IMAGE_VERSION,
  SHARE_IMAGE_WIDTH,
  buildShareImageRewrites,
};
